export const ROUTE_MAP = {
	auth: {
		logout: {
			path: '/logout',
			createPath: () => '/logout'
		}
	},

	surveys: {
		byId: {
			path: '/surveys/:surveyId',
			createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
				let path = `/surveys/${surveyId}`;
				if (language) {
					path += `?lang=${language}`;
				}
				return path;
			},
			form: {
				path: '/surveys/:surveyId/form',
				createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
					let path = `/surveys/${surveyId}/form`;
					if (language) {
						path += `?lang=${language}`;
					}
					return path;
				}
			},
			invalidPin: {
				path: '/surveys/:surveyId/invalid-pin',
				createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
					let path = `/surveys/${surveyId}/invalid-pin`;
					if (language) {
						path += `?lang=${language}`;
					}
					return path;
				}
			},
			expired: {
				path: '/surveys/:surveyId/expired',
				createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
					let path = `/surveys/${surveyId}/expired`;
					if (language) {
						path += `?lang=${language}`;
					}
					return path;
				}
			},
			maxAttemptsExceeded: {
				path: '/surveys/:surveyId/max-attempts-exceeded',
				createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
					let path = `/surveys/${surveyId}/max-attempts-exceeded`;
					if (language) {
						path += `?lang=${language}`;
					}
					return path;
				}
			},
			completed: {
				path: '/surveys/:surveyId/completed',
				createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
					let path = `/surveys/${surveyId}/completed`;
					if (language) {
						path += `?lang=${language}`;
					}
					return path;
				}
			},
			success: {
				path: '/surveys/:surveyId/success',
				createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
					let path = `/surveys/${surveyId}/success`;
					if (language) {
						path += `?lang=${language}`;
					}
					return path;
				}
			},
			noVariables: {
				path: '/surveys/:surveyId/no-variables',
				createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
					let path = `/surveys/${surveyId}/no-variables`;
					if (language) {
						path += `?lang=${language}`;
					}
					return path;
				}
			},
			noForm: {
				path: '/surveys/:surveyId/no-form',
				createPath: ({ surveyId, language }: { surveyId: string; language?: string }) => {
					let path = `/surveys/${surveyId}/no-form`;
					if (language) {
						path += `?lang=${language}`;
					}
					return path;
				}
			}
		}
	},

	projects: {
		path: '/projects',

		byId: {
			dataset: {
				path: '/projects/:projectId/dataset',
				createPath: ({ projectId }: { projectId: string }) =>
					`/projects/${projectId}/dataset`,

				codelist: {
					import: {
						path: '/projects/:projectId/dataset/codelist/import',
						createPath: ({ projectId }: { projectId: string }) =>
							`/projects/${projectId}/dataset/codelist/import`
					}
				},

				history: {
					path: '/projects/:projectId/dataset/history',
					createPath: ({ projectId }: { projectId: string }) =>
						`/projects/${projectId}/dataset/history`
				},

				create: {
					path: '/v1.5/projects/:projectId/dataset/create',
					createPath: ({
						projectId,
						formId
					}: {
						projectId: string;
						formId: string | null;
					}) => {
						const path = `/v1.5/projects/${projectId}/dataset/create`;

						if (formId) {
							return `${path}?formId=${formId}`;
						}

						return path;
					},

					print: {
						path: '/v1.5/projects/:projectId/dataset/print',
						createPath: ({
							projectId,
							formId
						}: {
							projectId: string;
							formId: string | null;
						}) => {
							const path = `/v1.5/projects/${projectId}/dataset/print`;
							if (formId) {
								return `${path}?formId=${formId}`;
							}

							return path;
						}
					}
				},

				update: {
					path: '/v1.5/projects/:projectId/dataset/update/:entryId',
					createPath: ({
						projectId,
						entryId,
						formId
					}: {
						projectId: string;
						entryId: string;
						formId: string | null;
					}) => {
						const path = `/v1.5/projects/${projectId}/dataset/update/${entryId}`;
						if (formId) {
							return `${path}?formId=${formId}`;
						}

						return path;
					},

					print: {
						path: '/v1.5/projects/:projectId/dataset/:entryId/print',
						createPath: ({
							projectId,
							entryId,
							formId
						}: {
							projectId: string;
							entryId: string;
							formId: string | null;
						}) => {
							const path = `/v1.5/projects/${projectId}/dataset/${entryId}/print`;
							if (formId) {
								return `${path}?formId=${formId}`;
							}

							return path;
						}
					},

					series: {
						bySeriesName: {
							path: '/v1.5/projects/:projectId/dataset/:entryId/series/:seriesName',
							pathWithout1_5:
								'/projects/:projectId/dataset/:entryId/series/:seriesName',

							createPath: ({
								projectId,
								entryId,
								seriesName
							}: {
								projectId: string;
								entryId: string;
								seriesName: string;
							}) =>
								`/v1.5/projects/${projectId}/dataset/${entryId}/series/${seriesName}`,

							create: {
								path: '/v1.5/projects/:projectId/dataset/:entryId/series/:seriesName/create',
								pathWithout1_5:
									'/projects/:projectId/dataset/:entryId/series/:seriesName/create',

								createPath: ({
									projectId,
									entryId,
									seriesName,
									formId
								}: {
									projectId: string;
									entryId: string;
									seriesName: string;
									formId: string | null;
								}) => {
									const path = `/v1.5/projects/${projectId}/dataset/${entryId}/series/${seriesName}/create`;
									if (formId) {
										return `${path}?formId=${formId}`;
									}

									return path;
								},

								print: {
									path: '/v1.5/projects/:projectId/dataset/:entryId/series/:seriesName/create/print',
									createPath: ({
										projectId,
										entryId,
										seriesName,
										formId
									}: {
										projectId: string;
										entryId: string;
										seriesName: string;
										formId: string | null;
									}) => {
										const path = `/v1.5/projects/${projectId}/dataset/${entryId}/series/${seriesName}/create/print`;
										if (formId) {
											return `${path}?formId=${formId}`;
										}

										return path;
									}
								}
							},

							update: {
								path: '/v1.5/projects/:projectId/dataset/:entryId/series/:seriesName/entry/:seriesEntryId/update',
								pathWithout1_5:
									'/projects/:projectId/dataset/:entryId/series/:seriesName/entry/:seriesEntryId/update',

								createPath: ({
									projectId,
									entryId,
									seriesName,
									seriesEntryId,
									formId
								}: {
									projectId: string;
									entryId: string;
									seriesName: string;
									seriesEntryId: string;
									formId: string | null;
								}) => {
									const path = `/v1.5/projects/${projectId}/dataset/${entryId}/series/${seriesName}/entry/${seriesEntryId}/update`;
									if (formId) {
										return `${path}?formId=${formId}`;
									}

									return path;
								},

								print: {
									path: '/v1.5/projects/:projectId/dataset/:entryId/series/:seriesName/entry/:seriesEntryId/update/print',
									createPath: ({
										projectId,
										entryId,
										seriesName,
										seriesEntryId,
										formId
									}: {
										projectId: string;
										entryId: string;
										seriesName: string;
										seriesEntryId: string;
										formId: string | null;
									}) => {
										const path = `/v1.5/projects/${projectId}/dataset/${entryId}/series/${seriesName}/entry/${seriesEntryId}/update/print`;
										if (formId) {
											return `${path}?formId=${formId}`;
										}

										return path;
									}
								}
							}
						}
					}
				}
			},
			collaborators: {
				path: '/projects/:projectId/collaborators',
				createPath: ({ projectId }: { projectId: string }) =>
					`/projects/${projectId}/collaborators`,
				invite: {
					path: '/projects/:projectId/collaborators/invite',
					createPath: ({ projectId }: { projectId: string }) =>
						`/projects/${projectId}/collaborators/invite`
				}
			}
		}
	},

	internalAdmin: {
		path: '/internal-admin'
	},

	studies: {
		path: '/studies'
	}
} as const;
